import React, { useEffect, useState } from 'react'
import { CartService } from './Service';
import { Box,Card,Grid, Table, TableBody, TableHead, TableRow, TableCell, Paper, IconButton, Typography, CircularProgress, Avatar, Rating, Divider } from '@mui/material';
import { deepPurple, orange } from '@mui/material/colors';
import { BookingService } from '../../Booking/Service';
import Swal from 'sweetalert2';
import { LocalStore } from '../../../storage/authStore';

const CartDetails = ({ CustomerCart }) => {
  const hasMyOperator = !!(LocalStore.getLoggedUserDetails()?.myOperatorUserId);

  /************ click-to-call related ***********/
  const handleInitiateCall = async (phone) => {
    if (!phone) return;
    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to call this expert?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, Call Now',
      cancelButtonText: 'Cancel',
    });
    if (!confirm.isConfirmed) return;
    try {
      const res = await BookingService.initiateCall({ number: phone, target: "customer" });
      if (res?.success === 1) {
        Swal.fire({ icon: 'success', title: 'Success', text: 'Call initiated successfully', timer: 2000, showConfirmButton: false });
      } else {
        Swal.fire({ icon: 'error', title: 'Failed', text: res?.message || 'Unable to initiate call' });
      }
    } catch {
      Swal.fire({ icon: 'error', title: 'Error', text: 'Unable to initiate call' });
    }
  };
    return (                
        <Card sx={{bgcolor: '#dadada4d', position: 'relative',maxHeight:'70vh',overflow:'auto' }} >                    
            <Grid container>
                <Grid item xs={12}>
                    {
                        CustomerCart && CustomerCart.length > 0 && CustomerCart.map((item, index) => (
                            <Box key={index}>
                                <Box sx={{ p: 1 }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, p: 1 }}>
                                        <Box sx={{ display: 'flex', alignItems: { xs: 'flex-start', sm: 'center' }, gap: 1 }}>
                                            <Avatar sx={{ bgcolor: index % 2 === 0 ? deepPurple[500] : orange[500], width: { xs: 25, sm: 50 }, height: { xs: 25, sm: 50 }, borderRadius: '.5rem' }} variant="square">E</Avatar>
                                            <Box>
                                                <Typography sx={{ fontSize: '.75rem', fontWeight: 600, color: '#3e3e3e' }}>{item?.provider?.UserProfile?.firstName} {item?.provider?.UserProfile?.lastName} ({item?.provider?.id})</Typography>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
  <Typography sx={{ fontSize: '.75rem', fontWeight: 600, color: '#3e3e3e' }}>Contact : {item?.provider?.mobileNumber}</Typography>
  {item?.provider?.mobileNumber && hasMyOperator && (
    <IconButton size="small" sx={{ ml: 0.5, p: 0.25, fontSize:'10px' }} onClick={() => handleInitiateCall(item?.provider?.mobileNumber)} color="primary">
      Click-to-Call
    </IconButton>
  )}
</Box>
                                                <Rating name="read-only" value={item?.provider?.avgRating} readOnly size='small' />
                                            </Box>
                                        </Box>
                                        <Box sx={{ pr: 1 }}>
                                            <Typography sx={{ fontSize: '.75rem', fontWeight: 600, color: '#3e3e3e' }}>Total Items: {item.cartItems.length}</Typography>
                                            <Typography sx={{ fontSize: '.75rem', fontWeight: 600, color: '#3e3e3e' }}></Typography>
                                        </Box>
                                    </Box>
                                    {/* { showIndex === index && */}
                                    <Box component={Paper} sx={{ width: '100%', overflowX: 'auto' }}>
                                        <Table sx={{ minWidth: 600 }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ fontWeight: 600, p: '1% 2%', fontSize: '.75rem' }} width="40%" >Service</TableCell>
                                                    <TableCell sx={{ fontWeight: 600, p: '1% 2%', fontSize: '.75rem' }} align="center" width="12%">Quantity</TableCell>
                                                    <TableCell sx={{ fontWeight: 600, p: '1% 2%', fontSize: '.75rem' }} align="center" width="12%">Time</TableCell>
                                                    <TableCell sx={{ fontWeight: 600, p: '1% 2%', fontSize: '.75rem' }} align="center" width="12%">Price</TableCell>
                                                    <TableCell sx={{ fontWeight: 600, p: '1% 2%', fontSize: '.75rem' }} align="center" width="12%">Total</TableCell>
                                                    {/* <TableCell sx={{ fontWeight: 600, p: '1% 2%', fontSize: '.75rem' }} align="right" width="12%" >Action</TableCell> */}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {item.cartItems.map((service) => (
                                                    <TableRow key={service.id}>
                                                        <TableCell sx={{ p: .5, fontSize: '.75rem' }}>{service.providerServiceCart.childService.title}</TableCell>
                                                        <TableCell align="center" sx={{ p: .5, fontSize: '.75rem' }}>
                                                                {service.quantity}
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ p: .5, fontSize: '.75rem' }}>
                                                            {(service.providerServiceCart.serviceTime) * service.quantity} mins
                                                        </TableCell>
                                                        <TableCell sx={{ p: .5, fontSize: '.75rem', textAlign: 'center' }}>₹{service.providerServiceCart.price}</TableCell>
                                                        <TableCell sx={{ p: .5, fontSize: '.75rem', textAlign: 'center' }} >₹{parseFloat(service.providerServiceCart.price * service.quantity).toFixed(2)}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </Box>
                                    {/* } */}
                                </Box>
                                {index < CustomerCart.length - 1 && <Divider sx={{ my: '1%', borderColor: '#3a2bde' }} />}
                            </Box>
                        ))
                    }
                </Grid>
            </Grid>
        </Card>   
    )
}

export default CartDetails